import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin } from 'lucide-react';
import { companyInfo, credentials, servicesList } from '../data/mock';
import { Button } from './ui/button';

const Footer = () => {
  return (
    <footer className="bg-neutral-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Company Info */}
          <div>
            <img 
              src={companyInfo.logoDark} 
              alt="Gray Contracting" 
              className="h-12 w-auto mb-6"
            />
            <p className="text-neutral-400 text-sm leading-relaxed mb-4">
              {companyInfo.description}
            </p>
            <div className="flex flex-wrap gap-2">
              {credentials.map((cred, i) => (
                <span key={i} className="text-xs bg-neutral-800 text-amber-400 px-2 py-1 rounded">
                  {cred}
                </span>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Our Services</h3>
            <ul className="space-y-3">
              {servicesList.map((service) => (
                <li key={service.id}>
                  <Link 
                    to={`/services/${service.id}`}
                    className="text-neutral-400 hover:text-amber-400 text-sm transition-colors"
                  >
                    {service.shortTitle}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-neutral-400 hover:text-amber-400 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-neutral-400 hover:text-amber-400 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-neutral-400 hover:text-amber-400 transition-colors">Services</Link></li>
              <li><Link to="/gallery" className="text-neutral-400 hover:text-amber-400 transition-colors">Gallery</Link></li>
              <li><Link to="/blog" className="text-neutral-400 hover:text-amber-400 transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="text-neutral-400 hover:text-amber-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Service Areas</h3>
            <ul className="space-y-2 text-sm text-neutral-400">
              <li><Link to="/services/residential-painting/dallas" className="hover:text-amber-400 transition-colors">Dallas</Link></li>
              <li><Link to="/services/residential-painting/plano" className="hover:text-amber-400 transition-colors">Plano</Link></li>
              <li><Link to="/services/residential-painting/frisco" className="hover:text-amber-400 transition-colors">Frisco</Link></li>
              <li><Link to="/services/residential-painting/richardson" className="hover:text-amber-400 transition-colors">Richardson</Link></li>
              <li><Link to="/services/residential-painting/irving" className="hover:text-amber-400 transition-colors">Irving</Link></li>
              <li><Link to="/services/residential-painting/garland" className="hover:text-amber-400 transition-colors">Garland</Link></li>
              <li className="text-amber-400 font-medium">
                <Link to="/services/residential-painting">+ 9 More Cities</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
            <div className="space-y-4">
              <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-3 text-neutral-400 hover:text-amber-400 transition-colors">
                <Phone className="w-5 h-5" />
                <span>{companyInfo.phone}</span>
              </a>
              <div className="flex items-start gap-3 text-neutral-400">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span>{companyInfo.addressFull}</span>
              </div>
            </div>
            <div className="mt-6">
              <Link to="/contact">
                <Button className="w-full bg-amber-500 hover:bg-amber-600 text-white">
                  Get Free Estimate
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-neutral-500">
              © {new Date().getFullYear()} Gray Contracting. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm text-neutral-500">
              <Link to="/" className="hover:text-amber-400 transition-colors">Privacy Policy</Link>
              <Link to="/" className="hover:text-amber-400 transition-colors">Terms of Service</Link>
              <a href="/sitemap-index.xml" className="hover:text-amber-400 transition-colors">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
